import React, { FC, useContext } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { HelpDeskInputFieldEnum } from 'context/HelpDeskTooltipContext/helpDeskInputFieldEnum';
import { HelpDeskTooltipContext } from 'context/HelpDeskTooltipContext';
interface HelpdeskInfoComponentProps {
  fieldKey: HelpDeskInputFieldEnum;
  className?: string;
}

const HelpdeskInfoComponent: FC<HelpdeskInfoComponentProps> = props => {
  const { className, fieldKey } = props;
  const { openTooltipModal } = useContext(HelpDeskTooltipContext);

  const handleToolTipOpen = (fieldName?: HelpDeskInputFieldEnum) => () =>
    fieldName && openTooltipModal(fieldName);
  return (
    <span className={className} onClick={handleToolTipOpen(fieldKey)}>
      <InfoCircleOutlined />
    </span>
  );
};

export default HelpdeskInfoComponent;
